/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

/**
 * Show the highlighter for the story.
 */
@Component({
  selector: 'app-profile-highlighter',
  templateUrl: './profile-highlighter.component.html',
  styleUrls: ['./profile-highlighter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileHighlighterComponent implements OnInit {

  /**
   * Main image for the highlighter.
   * Size of the highlighter
   * Active status of the highlighter.
   */
  @Input() backgroundImg: string;
  @Input() boxSize: number;
  @Input() activeStatus: boolean;

  public imageLoaded = false;



  constructor(private cd: ChangeDetectorRef) {

  }
  ngOnInit(): void {
    this.isImageLoaded();
  }
  waitForImages(productUrl): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.src = productUrl;
      if (productUrl) {
        img.onload = () => {
          resolve();
        };
        img.onerror = () => reject(`Failed to preload image: ${productUrl}`);
      }
    });
  }
  isImageLoaded(): void {
    if (this.backgroundImg) {
      this.waitForImages(this.backgroundImg).then(data => {
        this.imageLoaded = true;
        this.cd.markForCheck();
      }).catch(res => {
        this.imageLoaded = true;
      });
    }
  }

}
